export const GET_DEVICE_LIST_ATTEMPT = 'GET_DEVICE_LIST_ATTEMPT';
export const GET_DEVICE_LIST_SUCCESS = 'GET_DEVICE_LIST_SUCCESS';
export const GET_DEVICE_LIST_FAILURE = 'GET_DEVICE_LIST_FAILURE';
export const SET_SELECTED_DEVICE = 'SET_SELECTED_DEVICE';
export const REFRESH_DEVICE_LIST_ATTEMPT = 'REFRESH_DEVICE_LIST_ATTEMPT';
export const REFRESH_DEVICE_LIST_SUCCESS = 'REFRESH_DEVICE_LIST_SUCCESS';
export const REFRESH_DEVICE_LIST_FAILURE = 'REFRESH_DEVICE_LIST_FAILURE';
export const CLEAR_STATE = 'CLEAR_STATE';
